// extracted by mini-css-extract-plugin
export default {"song":"Song_song__8Q+Rf","img":"Song_img__+vkUE","info":"Song_info__9fZPP","artist":"Song_artist__BYB-U"};